module.exports = __webpack_public_path__ + "static/media/CrisBea.f0d73552.jpeg";